<template>
    <Layout>
        <PageHeader :title="title" :items="items" /> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-world bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{ $t('website.website-age-checker') }}</h5>
                        </div>
                    </div>
                    <div class="row mt-5 mb-3">
                        <div class="col-sm-12 mb-2 text-right">
                            <div class="input-group">
                                <input
                                id="search"
                                type="text"
                                class="form-control"
                                v-model="searchKey"
                                v-on:input="removeHttp(searchKey)"
                                placeholder="domainname.com"
                                aria-describedby="search"
                                @keyup.enter="searchWebsite"
                                />
                                <div class="input-group-prepend">
                                <button
                                    id="search"
                                    class="input-group-text bg-primary text-white"
                                    @click="searchWebsite"
                                >
                                    <i class="bx bx-search-alt search-icon"></i>
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>
                     <div v-if="loading" class="row mt-5 mb-5 pb-4 mx-auto">
                        <div class="text-center">
                              <div class="spinner-border text-secondary" role="status" v-if="loading">
                            <span class="sr-only"><p>{{ $t('website.website-location') }}</p></span>
                          </div> <br>
                          Loading ..
                        </div>
                    </div>
                      <div v-if="error !== '' && !loading" class="row mt-5 mb-5 pb-4  mx-auto">
                        <div class="text-center">
                           <span class="text-secondary">{{error}}</span>  
                        </div>
                    </div>
                      <div v-if="!SearchResult.createdDate && !loading && search && error == ''" class="row mt-5 mb-5 pb-4 mx-auto">
                        <div class="text-center">
                           <span class="text-secondary">{{ $t('all.dnf') }}</span>  
                        </div>
                    </div>
                 
                    <div v-if="SearchResult.createdDate" class="mt-0">
                            <p v-if="SearchResult.createdDate"><b>{{ $t('website.created_date') }}: </b> {{formatDate(SearchResult.createdDate)}}</p>
                            <p v-if="SearchResult.expiresDate"><b>{{ $t('website.expired_date') }}: </b> {{formatDate(SearchResult.expiresDate)}}</p>
                            <p v-if="Age"><b>{{ $t('website.domain_age') }}: </b> {{Age}}</p> 
                            <p v-if="years"><b>{{ $t('website.years') }}: </b> {{years}}</p> 
                            <p v-if="month"><b>{{ $t('website.month') }}: </b> {{month}}</p> 
                            <p v-if="days"><b>{{ $t('website.days') }}: </b> {{days}}</p>
                    </div>
                </div>
                </div>
            </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import {gmapApi} from 'vue2-google-maps';
import Swal from "sweetalert2";

export default {
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            error:'',
            search: false,
            searchKey: "",
            SearchResult: "",
            total_results: "",
            Age: "",
            month: "",
            years: "",
            days: "",
            checkedBulk:[],
            dnf:false,
            dnfp:false,
            is_spam:"",
            title: this.$t('website.website-age-checker'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-age-checker'),
                active: true
                }
            ],
        }
    },
    
  methods:{
         searchWebsite(){
          this.error = '';
          this.loading = true;
          this.search = true;
          this.SearchResult = ""
          const data = {
            "website": this.searchKey,
          }
          WebsiteService.searchDomainWhois(data)
          .then(response => {
                    this.SearchResult = response.data.output;
                    // console.log(response.data.output);
                    this.loading = false;
                    this.countAge();
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                    if( err.response.status == 500 ){
                      this.error = this.$t('all.error-500');
                    } else if( err.response.status == 404 ){
                      this.error = this.$t('all.error-404');
                    }
            });
        },
        countAge(){
            var date = this.formatDateAge(this.SearchResult.createdDate);
            var mount = Math.floor(moment(new Date()).diff(moment(date,"YYYY-MM-DD"),'month',true));
            var years = Math.floor(moment(new Date()).diff(moment(date,"YYYY-MM-DD"),'years',true));
            var days = Math.floor(moment(new Date()).diff(moment(date,"YYYY-MM-DD"),'days',true));
       
            var mm = mount;
            var yr = years;
            var dd = days;

            this.month = mm;
            this.years = yr;
            this.days = dd;

            var m = mm - (yr * 12);
            var dx = dd - (yr * 365);
            var ds = dx/12;
            var d = this.toFixed(ds);

            var day = parseInt(d);
            var month = m;
            var years = years;

            this.Age = years +' Years, '+ month +' Month, '+ day +' Days';

            // console.log(years, m, parseInt(d));
        },
        formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
      formatDateAge(value){
          return moment(value).format("YYYY-MM-DD");
      },
      removeHttp(url){
          let x = url.replace(/(^\w+:|^)\/\//, '').replace("/", "").replace('www.', '');
          return this.searchKey = x;
      },
      toFixed(value){
      return value.toFixed(0);
    },
    clearData(){
        this.SearchResult = "";
        this.searchKey = "";
    },
  },
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>